import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import TextInput from "../../common/TextInput";
import SelectInput from "../../common/SelectInput";
import Row from "../../common/Row";
import { Landen } from "../../../constants/DomainConstants";
import AutoComplete from "../../common/AutoComplete";

const ContactpersoonComponent = (props) => {
    const {
        model,
        selectedContactpersoon,
        onChange,
        onLandChange,
        onChangeContactpersoonSelection,
        errors,
        landen,
        postcodes,
        gemeenten,
        disabled,
        contactpersonen,
        validationMessageType
    } = props;

    const isBelgie = model.land === Landen.BELGIE;
    let isContact, isExistingContact;

    if (contactpersonen) {
        isContact = selectedContactpersoon !== "";
        isExistingContact = selectedContactpersoon !== "newContact";
    }
    else {
        isContact = true;
        isExistingContact = false;
    }

    return (
        <Fieldset title="Contactpersoon">
            {contactpersonen ?
                <Row>
                    <SelectInput
                        name="contactpersoon"
                        label="Contactpersoon"
                        size={12}
                        items={contactpersonen}
                        onChange={onChangeContactpersoonSelection}
                        disabled={disabled}
                        value={selectedContactpersoon}
                        validationMessage={errors ? errors['voornaam'] : ""}
                        validationMessageType={validationMessageType} />
                </Row>
                : null}
            {isContact && !isExistingContact ?
                <Row>
                    <TextInput
                        name="voornaam"
                        size={6}
                        label="Voornaam"
                        value={model.voornaam}
                        onChange={onChange}
                        disabled={disabled}
                        validationMessage={errors ? errors['voornaam'] : ""}
                        validationMessageType={validationMessageType} />

                    <TextInput
                        name="naam"
                        size={6}
                        label="Naam"
                        value={model.naam}
                        onChange={onChange}
                        disabled={disabled}
                        validationMessage={errors ? errors['naam'] : ""}
                        validationMessageType={validationMessageType} />
                </Row>
                : null}
            {isContact ?
                < Row >
                    <SelectInput
                        name="land"
                        size={6}
                        items={landen}
                        onChange={onLandChange}
                        disabled={disabled}
                        value={model.land}
                        validationMessage={errors ? errors['land'] : ""}
                        validationMessageType={validationMessageType} />
                </Row>
                : null}
            {isContact ?
                <Row>
                    <TextInput
                        name="straatEnHuisnummer"
                        size={12}
                        label="Straat en nummer"
                        value={model.straatEnHuisnummer}
                        onChange={onChange}
                        disabled={disabled}
                        validationMessage={errors ? errors['straatEnHuisnummer'] : ""}
                        validationMessageType={validationMessageType} />
                </Row>
                : null}
            {isContact ? isBelgie ?
                <Row>
                    <AutoComplete
                        name="postcode"
                        label="Postcode"
                        size={3}
                        items={postcodes}
                        onChange={onChange}
                        disabled={disabled}
                        value={model.postcode}
                        validationMessage={errors ? errors['postcode'] : ""}
                        validationMessageType={validationMessageType}
                    />
                    <AutoComplete
                        name="gemeente"
                        label="Gemeente"
                        size={9}
                        items={gemeenten}
                        onChange={onChange}
                        disabled={disabled}
                        value={model.gemeente}
                        validationMessage={errors ? errors['gemeente'] : ""}
                        validationMessageType={validationMessageType}
                    />
                </Row>
                :
                <Row>
                    <TextInput
                        name="postcodeNietBelgie"
                        label="Postcode"
                        size={3}
                        onChange={onChange}
                        disabled={disabled}
                        value={model.postcodeNietBelgie}
                        validationMessage={errors ? errors['postcodeNietBelgie'] : ""}
                        validationMessageType={validationMessageType} />
                    <TextInput
                        name="gemeenteNietBelgie"
                        label="Gemeente"
                        size={9}
                        onChange={onChange}
                        disabled={disabled}
                        value={model.gemeenteNietBelgie}
                        validationMessage={errors ? errors['gemeenteNietBelgie'] : ""}
                        validationMessageType={validationMessageType} />
                </Row>
                : null}
            {isContact ?
                <Row>
                    <TextInput
                        name="email"
                        size={6}
                        label="E-mail"
                        value={model.email}
                        onChange={onChange}
                        disabled={disabled}
                        validationMessage={errors ? errors['email'] : ""}
                        validationMessageType={validationMessageType} />
                    <TextInput
                        name="telefoon"
                        size={6}
                        label="Telefoon / GSM"
                        value={model.telefoon}
                        onChange={onChange}
                        disabled={disabled}
                        validationMessage={errors ? errors['telefoon'] : ""}
                        validationMessageType={validationMessageType} />
                </Row>
                : null}
        </Fieldset>
    );
};

ContactpersoonComponent.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onLandChange: PropTypes.func.isRequired,
    onChangeContactpersoonSelection: PropTypes.func.isRequired,
    selectedContactpersoon: PropTypes.string,
    federaties: PropTypes.object,
    landen: PropTypes.array,
    postcodes: PropTypes.array,
    gemeenten: PropTypes.array,
    contactpersonen: PropTypes.array,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    validationMessageType: PropTypes.string
};

export default ContactpersoonComponent;